import { message, Modal } from "antd";
import React from "react";
import {
    convertQuestion,
    QuestionListItem,
    QuestionType,
    removeQuestion,
    saveQuestion
} from "service/question";
import { errorMessage } from "service/service";
import usePromiseCallback from "utils/usePromiseCallback";
import TopicDetail from "../TopicDetail";
import style from "./index.module.scss";
import AddTopicModal from "../AddTopicModal";
import useModalHandler from "utils/useModalHandler";
import { useAtomValue } from "jotai";
import { typeIdsAtom } from "../../../../../../service/stores/Question/QuestionTypes";

interface TopicContentProps {
    currentData: QuestionListItem;
    questionnaireId: string;
    refreshData: () => void;
}

export default function TopicContent({
    currentData,
    questionnaireId,
    refreshData
}: TopicContentProps) {
    const topicModal = useModalHandler();
    const question = convertQuestion(currentData);

    //删除题目
    const onDelete = usePromiseCallback(async function () {
        Modal.confirm({
            title: `确认删除题目吗？`,
            onOk: async () => {
                try {
                    await removeQuestion(
                        questionnaireId,
                        String(currentData.id)
                    );
                    message.success("删除成功!");
                    refreshData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    async function onQuestionChange(data: QuestionType) {
        await saveQuestion({
            ...data,
            paperId: String(currentData.paperId),
            id: String(currentData.id)
        });
        message.success("保存成功!");
        refreshData();
    }

    const allTypeIds = useAtomValue(typeIdsAtom);

    return (
        <div className={style.root}>
            <div className={style.tools}>
                <button
                    className={style.edit}
                    title="修改"
                    onClick={topicModal.open}
                />
                <button
                    className={style.delete}
                    title="删除"
                    onClick={onDelete}
                />
            </div>

            <TopicDetail data={currentData} />

            {topicModal.render(
                <AddTopicModal
                    key={question.id}
                    title="编辑题目"
                    initialValue={question}
                    onOk={onQuestionChange}
                    types={allTypeIds}
                />
            )}
        </div>
    );
}
